/**
 * When the attention column is on screen (2026-10-06, "the column only
 * when something is wrong", `OverviewFrame`). Its own file, so the frame's
 * file exports only components (react-refresh), as `attention-actions.ts`
 * does for the card buttons.
 */
import type { AttentionModel } from '../../../state/attention/select';

/** Whether the attention column is on screen for this model: not while
 *  it reads "All clear" or is still checking. */
export function attentionColumnShown(model: AttentionModel): boolean {
  return model.verdict.kind !== 'all_clear' && model.verdict.kind !== 'checking';
}
